// EventEvidenceTab — evidence attached to the current event.
// Thin wrapper around the shared EvidenceTab component.

import { useParams } from '@tanstack/react-router'
import { useApi } from '@/lib/api/client'
import { useTenant } from '@/components/shared/TenantShell'
import { eventsApi } from '@/lib/api/events'
import { queryKeys } from '@/lib/api/queryKeys'
import { EvidenceTab } from '@/components/features/evidence'
import { useAuth } from 'react-oidc-context'

export function EventEvidenceTab() {
  const { slug } = useTenant()
  const { eventId } = useParams({ strict: false }) as { eventId: string }
  const api = useApi()
  const auth = useAuth()
  const evtApi = eventsApi(api)

  return (
    <EvidenceTab
      queryKey={queryKeys.events.evidence(slug, eventId)}
      fetchFn={(includeArchived) => evtApi.evidence(eventId, includeArchived)}
      uploadFn={(params) =>
        evtApi.uploadEvidence(eventId, {
          file: params.file,
          evidenceTagId: params.evidenceTagId,
          comment: params.comment,
        })
      }
      downloadFn={(url) =>
        fetch(url, {
          headers: { Authorization: `Bearer ${auth.user?.id_token ?? ''}` },
        })
      }
      archiveFn={(evidenceId) => evtApi.archiveEvidence(eventId, evidenceId)}
      entityNoun="event"
    />
  )
}
